module.exports = __webpack_public_path__ + "img/new_21_1.e50ae163.png";